<div class="right-side p-5">

  <h2>Update Upload Documents</h2>

  <div class="section">

    <div class="table-responsive">

      <!-- Top Button -->

      <div class="text-end">

        <button class="btn btn-sm btn-success me-2"
                (click)="onUploadDocuments()">

          <i class="bi bi-upload"></i>

          Upload Documents

        </button>

      </div>

      <!-- Search -->

      <div class="col-lg-7 col-sm-12">

        <mat-form-field appearance="outline"
                        class="search-input w-75">

          <mat-label>Search...</mat-label>

          <input matInput
               [(ngModel)]="searchText"

                 (keyup.enter)="loadData()" />

        </mat-form-field>

        <!-- Search Button -->

        <button class="btn btn-outline-secondary p-2 mx-1 search-button"
                (click)="loadData()">

          <i class="bi bi-search fs-4"></i>

        </button>

        <!-- Reset -->

        <button class="btn btn-outline-secondary p-2"
                (click)="resetFilters()">

          <i class="bi bi-arrow-clockwise fs-4"></i>

        </button>

      </div>

      <!-- Table -->

      <table class="table table-striped table-bordered table-hover">

        <thead>

          <tr>

            <th>Sr.No</th>

            <th (click)="sort('EventId')">
              Event Id ⬍
            </th>

            <th (click)="sort('DocumentType')">
              Document Type ⬍
            </th>

            <th (click)="sort('DocumentName')">
              Document Name ⬍
            </th>

            <th>
              Original File
            </th>

            <th (click)="sort('CreatedOn')">
              Uploaded Date ⬍
            </th>

            <!--<th>
              Uploaded By
            </th>-->

            <th>
              Attachment
            </th>

          </tr>

        </thead>

        <tbody>

          <tr *ngFor="let row of dataSource; let i = index">

            <td>
              {{ (pagination.pageNumber - 1) * pagination.pageSize + i + 1 }}
            </td>

            <td>{{ row.eventId }}</td>

            <td>{{ row.documentType }}</td>

            <td>{{ row.documentName }}</td>

            <td>{{ row.originalFileName }}</td>

            <td>{{ row.createdOn | date:'dd/MM/yyyy' }}</td>

            <!--<td>{{ row.createdBy }}</td>-->

            <td>

              <button *ngIf="row.relativePath"
                      class="btn btn-sm btn-primary"
                      (click)="downloadFile(row)">

                <i class="bi bi-download"></i>

              </button>

            </td>

          </tr>

          <tr *ngIf="dataSource.length === 0">

            <td colspan="8" class="text-center">
              No data available
            </td>

          </tr>

        </tbody>

      </table>

    </div>

    <!-- Pagination -->

    <mat-paginator [length]="totalRecords"
                   [pageSize]="pagination.pageSize"
                   [pageIndex]="pagination.pageNumber - 1"
                   [pageSizeOptions]="[5, 10, 20, 50]"
                   (page)="onPageChange($event)">

    </mat-paginator>

  </div>

</div>
